import moment from "moment";
import styles from "./ListViewFaculty.module.css";
import React, { useEffect, useRef, useState } from "react";
import { useParams, useLocation, Link, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
import { validateTeachingProgress } from "./validateTeachingProgress";
import toast from "react-hot-toast";
import { ISTDateFormat } from "../../../../utils/helper";
import { Modal } from "react-bootstrap";

export default function StaffDetailCalendar() {
  const modalCloseRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState({});
  const [open, setOpen] = useState(false);

  const { id, staff_id } = location.state || {};
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let role_id = null;
  let user_type = null;
  let staff_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      role_id = user.role_id;
      user_type = user.user_type;
      staff_type = user.staff_type
    }
  } else {
    console.log("User Id cannot available in session storage");
  }

  // useEffect(() => {
  //   AxiosInstance.post("api/event/findById", {
  //     id: id,
  //     staff_id: staff_id,
  //     event_type: 0,
  //   })
  //     .then((res) => {
  //       if (res.data.status === true) {
  //         let el = res.data.data;
  //         setFdata((prevStates) => ({
  //           ...prevStates,
  //           title: el.name,
  //           sDate:
  //             el.start_date !== null
  //               ? moment(el.start_date).format("YYYY-MM-DD")
  //               : "",
  //           startTime: el.start_time,
  //           endTime: el.end_time,
  //           subject: el.subject,
  //           staff_name: el.staff_name,
  //           description: el.staff_description,
  //           batchName: el.batch_name,
  //           category: el.category,
  //           course: el.category_class,
  //           classMode: el.class_mode,
  //           medium: el.medium,
  //           location: el.location,
  //           teams_url: el.teams_url,
  //           batch_id: el.batch_id,
  //           staff_id: el.staff_id,
  //           event_id: el.id,
  //         }));
  //         let tp =
  //           res.data.teaching_progress !== ""
  //             ? res.data.teaching_progress
  //             : null;
  //         if (tp !== null) {

  //           setFormData((prevState) => ({
  //             ...prevState,
  //             id: tp.pk,
  //             topic_covered: tp.topics_covered,
  //             topics_pending: tp.topics_pending,
  //             percentage_completion: tp.completed_perc,
  //             comments: tp.comment,
  //           }));
  //           let Com =
  //             res.data.teaching_progress_comment.length > 0
  //               ? res.data.teaching_progress_comment
  //               : null;
  //           if (Com !== null) {
  //             setCommentSec(Com);
  //           }
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       return error;
  //     });
  // }, []);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };
  const today = new Date();
  const [subject_name, setSubject_name] = useState([]);
  const [fdata, setFdata] = useState({
    type:"",
    title: "",
    sDate: "",
    startTime: "",
    endTime: "",
    subject: "",
    staff_name: "",
    staff_id: "",
    event_id: "",
    description: "",
    batchName: "",
    category: "",
    course: "",
    classMode: "",
    medium: "",
    location: "",
    teams_url: "",
    batch_id: "",
  });


  const [formData, setFormData] = useState({
    id: "",
    topic_covered: "",
    topics_pending: "",
    percentage_completion: "",
    comments: "",
  });
  const [tempData, setTempData] = useState({
    topic_covered: "",
    topics_pending: "",
    percentage_completion: "",
    comments: "",
  });


  const [fs, setFs] = useState([
    {
      teaching_comment: "",
      user_type: user_type === 1 ? "admin" : "staff",
    },
  ]);
  const [commentSec, setCommentSec] = useState([
    {
      pk: "",
      staff_id: "",
      staff_type: "",
      teachprog_id: "",
      user_type: user_type === 1 ? 0 : 1,
      comment: "",
    },
  ]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setTempData(prev => ({ ...prev, [name]: value }));
    setError({
      ...error,
      [name]: "",
    });
  };
  const [flagReload, setFlagReload] = useState(false);

  useEffect(() => {
    findByidBook(id);
  }, [flagReload, id]);
  const findByidBook = (booksd_id) => {
    AxiosInstance.post("api/event/findById", {
      id: id,
      staff_id: staff_id,
      event_type: 0,
    })
      .then((res) => {
        if (res.data.status === true) {
          let el = res.data.data;
          let elSubject = res.data.subject_test_topics;
          setSubject_name(elSubject)
          setFdata((prevStates) => ({
            ...prevStates,
            title: el.name,
            type:el.type,
            sDate:
              el.start_date !== null
                ? moment(el.start_date).format("YYYY-MM-DD")
                : "",
            startTime: el.start_time,
            endTime: el.end_time,
            subject: el.subject,
            staff_name: el.staff_name,
            description: el.staff_description,
            batchName: el.batch_name,
            category: el.category,
            course: el.category_class,
            classMode: el.class_mode,
            medium: el.medium,
            location: el.location,
            teams_url: el.teams_url,
            batch_id: el.batch_id,
            staff_id: el.staff_id,
            event_id: el.id,
          }));
          let tp =
            res.data.teaching_progress !== ""
              ? res.data.teaching_progress
              : null;
          if (tp !== null) {
            const updatedProgress = {
              id: tp.pk,
              topic_covered: tp.topics_covered,
              topics_pending: tp.topics_pending,
              percentage_completion: tp.completed_perc,
              comments: tp.comment,
            };
            setTempData(updatedProgress);
            setFormData((prevState) => ({
              ...prevState,
              id: tp.pk,
              topic_covered: tp.topics_covered,
              topics_pending: tp.topics_pending,
              percentage_completion: tp.completed_perc,
              comments: tp.comment,
            }));
            let Com =
              res.data.teaching_progress_comment.length > 0
                ? res.data.teaching_progress_comment
                : null;
            if (Com !== null) {
              setCommentSec(Com);
            }
          }
        }
      })
      .catch((error) => {
        return error;
      });
  }
  const handleTeachingProgress = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    const errors = validateTeachingProgress(tempData);
    if (Object.keys(errors).length === 0) {
      try {
        if (formData.id !== null && formData.id !== "") {
          const Updat = {
            pk: formData.id,
            staff_id: parseInt(fdata.staff_id),
            staff_type: 0,
            event_id: fdata.event_id,
            batch_id: fdata.batch_id,
            topics_covered: tempData.topic_covered,
            topics_pending: tempData.topics_pending,
            completed_perc: tempData.percentage_completion,
            comment: tempData.comments,
            created_by: userid,
            updated_by: userid,
          };

          AxiosInstance.post("api/staff/teachProg/edit", Updat)
            .then((res) => {
              if (res.data.status === true) {
                toast.success(res.data.message);
                handleModelClose();
                setFlagReload(!flagReload);
                const modal = document.querySelector("#TeachingModel");
                const modal_close = modalCloseRef.current;
                if (modal && modal_close) {
                  modal_close.click();
                }
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        } else {
          const dat = {
            staff_id: parseInt(fdata.staff_id),
            staff_type: 0,
            event_id: fdata.event_id,
            batch_id: fdata.batch_id,
            topics_covered: tempData.topic_covered,
            topics_pending: tempData.topics_pending,
            completed_perc: tempData.percentage_completion,
            comment: tempData.comments,
            created_by: userid,
            updated_by: userid,
          };
          AxiosInstance.post("api/staff/teachProg/add", dat)
            .then((res) => {
              if (res.data.status === true) {
                toast.success(res.data.message);
                handleModelClose();
                setFlagReload(!flagReload);
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(errors);
    }
  };
  const handleMeeting = () => {
    window.open(fdata.teams_url, "_blank");
  };
  const handleDateToday = (date) => {

    const givenDate = new Date(date);
    if (givenDate.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
      return true;
    } else {
      return false;
    }
  };
  const [isTeachingProgressEnabled, setIsTeachingProgressEnabled] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      // Step 1: Parse the date
      const dateFormat = fdata.sDate.includes("-")
        ? "YYYY-MM-DD"
        : "DD/MM/YYYY";
      const classDate = moment(fdata.sDate, dateFormat);

      // Step 2: Combine date and time
      const startDateTime = moment(
        `${classDate.format("YYYY-MM-DD")} ${fdata.startTime}`,
        "YYYY-MM-DD HH:mm:ss"
      );
      const endDateTime = moment(
        `${classDate.format("YYYY-MM-DD")} ${fdata.endTime}`,
        "YYYY-MM-DD HH:mm:ss"
      );

      // Step 3: Subtract 10 minutes from the start time
      const tenMinutesBeforeStart = moment(startDateTime).subtract(
        10,
        "minutes"
      );

      // Step 4: Compare with current time
      const now = moment();
      const updatedButtonDisabled =
        now.isBefore(tenMinutesBeforeStart) || now.isAfter(endDateTime);

      setIsButtonDisabled(updatedButtonDisabled);
      setIsTeachingProgressEnabled(now.isAfter(endDateTime));
    }, 1000);

    return () => clearInterval(interval);
  }, [fdata.sDate, fdata.startTime, fdata.endTime, id]);
  const handleSubmit = () => {
    setOpen(true);
  };
  const handleModelClose = () => {
    setOpen(false);
    setError({});
    setTempData(formData);
  };
  return (
    <>
      <div
        className={`${styles.cm_container} BathHeader container-fluid  global_container p-0 BathDet`}
        style={{ marginTop: 0 }}
        id="ex2-content"
      >
        <div className={"tab-pane fade show active col-md-12"}>
          <div className="row align-items-center">
            <div className="col-md-12 d-flex justify-content-between align-items-center flex-wrap">
              {/* Left Side - Heading */}
              <div className="mb-2">
                <h2 className="TitleHeader mb-0">View Class</h2>
              </div>

              {/* Right Side - Buttons */}
              <div className="d-flex flex-wrap gap-2">
                {/* Back Button */}
                <Link
                  to="javascript:void(0)"
                  onClick={navigateToPreviousScreen}
                  className="secondaryButton"
                >
                  {staff_type === 3 ? "Back" : "Back to Batches"}
                </Link>

                {/* Edit Teaching Progress - only if user_type === 3 and date is today */}


                {fdata.type !== 5 && isTeachingProgressEnabled && (

                  <Link
                    onClick={handleSubmit}
                    to="javascript:void(0)"
                    className="primaryButton "
                    variant="primary"
                  >
                    Edit Teaching Progress
                  </Link>
                )}

                {/* Join Class Button */}
                <Link
                  to="javascript:void(0)"
                  onClick={(e) => {
                    if (isButtonDisabled || !fdata.teams_url) {
                      e.preventDefault();
                      return;
                    }
                    handleMeeting();
                  }}
                  className={`primaryButton ${isButtonDisabled ? "disabledbtn" : ""
                    }`}
                  variant="primary"
                >
                  Join Class
                </Link>
              </div>
            </div>
          </div>

          <fieldset className="mt-3">
            <legend className="w-auto">Event Details</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Event Name</p>
                      <p className="confirm_value my-1">
                        {fdata.title !== null ? fdata.title : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Batch Name</p>
                      <p className="confirm_value my-1">
                        {fdata.batchName !== null ? fdata.batchName : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Category</p>
                      <p className="confirm_value my-1">
                        {fdata.category !== null ? fdata.category : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Course </p>
                      <p className="confirm_value my-1">
                        {fdata.course !== null ? fdata.course : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Class Mode</p>
                      <p className="confirm_value my-1">
                        {fdata.classMode !== null
                          ? fdata.classMode === "ClassRoom"
                            ? "Classroom"
                            : fdata.classMode
                          : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Medium</p>
                      <p className="confirm_value my-1">
                        {fdata.medium !== null ? fdata.medium : "⎯"}
                      </p>
                    </div>
                  </div>
                  {fdata.classMode !== "Online" && (
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">Location</p>
                        <p className="confirm_value my-1">
                          {fdata.location !== null && fdata.location !== ""
                            ? fdata.location
                            : "⎯"}
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Date</p>
                      <p className="confirm_value my-1">
                        {fdata.sDate !== null
                          ? ISTDateFormat(fdata.sDate)
                          : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Start Time</p>
                      <p className="confirm_value my-1">
                        {fdata.startTime !== null
                          ? moment(fdata.startTime, "HH:mm:ss").format("h:mm A")
                          : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">End Time</p>
                      <p className="confirm_value my-1">
                        {fdata.endTime !== null
                          ? moment(fdata.endTime, "HH:mm:ss").format("h:mm A")
                          : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Subject</p>
                      <p className="confirm_value my-1">
                        {subject_name.map((item) => item.subject_name).join(", ") || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0"> Faculty Name</p>
                      <p className="confirm_value my-1">
                        {fdata.staff_name !== null ? fdata.staff_name : "⎯"}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        {" "}
                        Instruction to Faculty
                      </p>
                      <p className="confirm_value my-1">
                        {fdata.description !== null ? fdata.description : "⎯"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          {isTeachingProgressEnabled && (
            <fieldset className="mt-3">
              <legend className="w-auto">Teaching Progress</legend>
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0"> Topics Covered</p>
                        <p className="confirm_value my-1">
                          {formData.topic_covered !== null &&
                            formData.topic_covered !== ""
                            ? formData.topic_covered
                            : "⎯"}
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0"> Topics Pending</p>
                        <p className="confirm_value my-1">
                          {formData.topics_pending !== null &&
                            formData.topics_pending !== ""
                            ? formData.topics_pending
                            : "⎯"}
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0">
                          {" "}
                          Percentage of Completion
                        </p>
                        <p className="confirm_value my-1">
                          {formData.percentage_completion !== null &&
                            formData.percentage_completion !== ""
                            ? formData.percentage_completion
                            : "⎯"}
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-12 mb-3">
                      <div className="d-flex flex-column">
                        <p className="confirm_label m-0"> Comments</p>
                        <p className="confirm_value my-1">
                          {formData.comments !== null &&
                            formData.comments !== ""
                            ? formData.comments
                            : "⎯"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          )}

          {isTeachingProgressEnabled && (
            <fieldset className="mt-3">
              <legend className="w-auto">Comments</legend>
              <div className="row mb-3">
                <div className="col-md-12">
                  {commentSec.length > 0 ? (
                    commentSec.map((el, index) => (
                      <div className="row" key={index}>
                        <div className="col-lg-3 col-md-6 col-12 mb-3">
                          <div className="d-flex flex-column">
                            <p className="confirm_label m-0">
                              {el.user_type === 0
                                ? "Comment by Admin"
                                : "Reply by Faculty"}
                            </p>
                            <p className="confirm_value my-1">
                              {el.comment?.trim() ? el.comment : "⎯"}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No comments available.</p>
                  )}
                </div>
              </div>
            </fieldset>
          )}
        </div>
      </div>

      {open && (
        <Modal
          key={`modal-0-${0}`}
          show={open}
          onHide={handleModelClose}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h5
                className={`${styles.view_title} fw-bold mb-0`}
                id="exampleModalLabel"
              >
                Edit Teaching Progress
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <></>
            <div className="row global_container">
              <div className="col-12">
                <form className="row ">
                  <div class="col-md-6">
                    <label for="topic_covered" class="form-label confirm_value ">
                      Topics Covered
                    </label>
                    <input
                      // ref={book_name_ref}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                      type="text"
                      value={tempData.topic_covered}
                      onChange={handleChange}
                      id="topic_covered"
                      name="topic_covered"
                      placeholder="Enter Topic covered"
                    />
                    {error.topic_covered && (
                      <small className="error_message">{error.topic_covered}</small>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label for="topics_pending" class="form-label confirm_value ">
                      Topics Pending
                    </label>
                    <input
                      // ref={book_name_ref}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                      type="text"
                      value={tempData.topics_pending}
                      onChange={handleChange}
                      id="topics_pending"
                      name="topics_pending"
                      placeholder="Enter Pending Topic"
                    />
                    {error.topics_pending && (
                      <small className="error_message">{error.topics_pending}</small>
                    )}
                  </div>

                  <div className="col-md-6 ">
                    <label for="bookName" class="form-label confirm_value mt-2">
                      Percentage of Completion
                    </label>
                    <input
                      // ref={book_name_ref}
                      class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                      type="number"
                      value={tempData.percentage_completion}
                      onChange={handleChange}
                      id="percentage_completion"
                      name="percentage_completion"
                      placeholder="Enter percentage"
                    />
                    {error.percentage_completion && (
                      <small className="error_message">{error.percentage_completion}</small>
                    )}
                  </div>

                  <div class="col-12">
                    <label for="comments" class="form-label confirm_value mt-2">
                      Comments
                    </label>
                    <textarea
                      // ref={description_ref}
                      maxLength={1500}
                      rows="4"
                      name="comments"
                      id="comments"
                      onChange={handleChange}
                      defaultValue={tempData.comments}
                      className="desc_input_text w-100 rounded-2 input-font-size-sm"
                      placeholder="Comments"
                    ></textarea>

                    {error.comments && (
                      <span className="error_message">{error.comments}</span>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <ul className="List-Button">
              <li className="ListBtnItems">
                <Link onClick={handleModelClose} className="secondaryButton">
                  Back to View Event
                </Link>
              </li>
              <li className="ListBtnItems">
                <Link onClick={handleTeachingProgress} className="primaryButton">
                  Save Teaching Progress
                </Link>
              </li>
            </ul>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
